import template from './import_time_log_help.html';
import * as Utils from '../../../lib/savanna_utils.js';

class TimeImportHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class TimeImportHelpPage
{
	constructor (bindings) {
		this.viewModel = new TimeImportHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

// Register the dialog
export default {
	name: 'TimeImportHelp',
	dialog_class: TimeImportHelpPage,
	template: template,
	template_filename: 'translation/dialogs/import_time_log_help',
	provider: 'ps'
};
